<template>
  <div class="index">
    <div class="model">
      <div class="body">
        <p class="title"></p>
        <p class="content"></p>
        <p class="btns" style="display:none">
          <span class="cancel">取消</span>
          <span class="confirm">确定</span>
        </p>
        <p class="foot"></p>
      </div>
    </div>
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    
    <div class="main" id="voucherPage" style="margin-top:0;">
      <div class="title">
        <p class="zhongan">WiFi安全险</p>
        <div class="already" v-if="obj.status == 1">已参保</div>
        <div class="already" v-if="obj.status == 2" style="color:#0285F0">处理中</div>
        <p class="status" v-if="obj.status == 1"></p>
        <p class="status" v-if="obj.status == 2"></p>
        <div class="logo"></div>
        <div class="al-item" style="margin-top:16px">
          <div class="left">累计最高赔付人民币</div>
          <div class="right">￥100000元</div>
        </div>
        <div class="al-item">
          <div class="left">单日/单次最高赔付人民币</div>
          <div class="right">￥20000元</div>
        </div>
        <div class="al-item">
          <div class="left">保障期限</div>
          <div class="right">{{obj.start_time}}至2023年9月15日</div>
        </div>
        <div class="al-item">
          <div class="left">支付金额</div>
          <div class="right">￥0.00元</div>
        </div>
        <div class="al-item">
          <div class="left">保险详细</div>
          <a class="right a" @click="clickRange" href="#/range">保障范围</a>
        </div>
        <div class="al-item" style="padding-bottom:24px">
          <div class="left">服务热线</div>
          <a class="right a" @click="range" href="tel:4009999595">400-999-9595</a>
        </div>
      </div>
      <qa :type="2"></qa>
      <div class="logo-image"></div>
      <div class="copyright">南京尚网网络科技有限公司对以上信息保留最终解释权</div>
      <div style="position:fixed;bottom:0;width:100%;margin-top:15px; display: flex">
        <div
          class="bottom_btn"
          id="btn_claim"
          @click="goClaim"
          v-bind:class="{halfwidth:claimList}"
        >我要索赔</div>
        <router-link
          class="bottom_btn claimList"
          to="/claimList"
          v-show="claimList"
          v-bind:class="{halfwidth: claimList}"
          style="display:inline-block"
        >
          <div @click="clickClaimList">索赔记录</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import qa from "@/components/qa";

const AES = require("@/lib/Utils/AES").default;
export default {
  name: "newdetail",
  components: {
    qa,
  },
  mounted: function () {
    var _self = this;
    Utils.Bridge.call("getAppInfo", {
      success: function (o) {
        _self.appinfo = o;
        _self.checkStatus();
        _self.$trace.enterTraceDone({ page: 1, login: "have_login" });
      },
    });
  },
  data() {
    return {
      msg: "tests",
      obj: "",
      appinfo: "",
      createBtn: 1,
      loading: false,
      claimList: false,
      appid: this.$route.query.appid,
    };
  },
  methods: {
    toRange: function () {
      if (this.appinfo.chanid == "ivvi") {
        this.$router.push("/rangeIvvi");
        this.$trace.trace("ins_detail", { type: "rangeIvvi" });
      } else if (this.appinfo.appid == "A0009") {
        this.$router.push("/rangeA0009");
        this.$trace.trace("ins_detail", { type: "rangeA0009" });
      } else if (this.appinfo.appid == "I0010") {
        this.$router.push("/rangeIos");
        this.$trace.trace("ins_detail", { type: "rangeIos" });
      } else {
        this.$router.push("/range");
        this.$trace.trace("ins_detail", { type: "range" });
      }
      console.log(`查看保险详情`);
    },
    clickRange() {
      this.$trace.trace("ins_mine_detail", 'ind');
      console.log(`点保障范围`);
    },
    clickClaimList() {
      this.$trace.trace("ins_mine_record", 'ind');
      console.log(`点索赔记录`);
    },
    range() {

    },
    goCreate: function () {

      this.$trace.trace("ins_join", "have_login");
      console.log(`参保：已登录`);

      this.$router.push("/create");
    },
    goClaim: function () {
      this.$trace.trace("ins_mine_claim", 'ind');
      console.log(`我要索赔`);
      if (this.obj.status == 2) {
        safe.model({
          title: "温馨提示",
          content: "您有一笔保单正在索赔中，不能提交新的索赔",
          foot: "我知道了",
        });
        safe.bindModelEvent();
        return;
      } else {
        this.$router.push("/claimStep1");
      }
    },
    checkStatus: function () {
      var _self = this;
      _self.loading = true;

      let data = {
        dhid: _self.appinfo.dhid,
        uhid: _self.appinfo.uhid,
        vcode: _self.appinfo.vcode,
      };
      let ed = AES.Encrypt(JSON.stringify(data), AES.obj());

      this.$http
        .post(
          _host + "/user/get",
          {
            ed: ed,
          },
          {
            emulateJSON: true,
          }
        )
        .then(function (response) {
          _self.loading = false;
          var json = response.body;
          if (json.c == "0000") {
            document.title = "我的保障";

            _self.$trace.enterTraceDone({ page: 2 });
            _self.obj = json.m;
            _self.obj.end_time = _self.obj.end_time || "2023年9月15日24时";
            var status = json.m.status,
              hasList = json.m.has_list;
            if (status == "2") {
              $("body").addClass("claim");
            }
            if (hasList == "2") {
              $(".bottom_btn").css("width", "50%");
              _self.claimList = true;
            }
          } else {
            _self.createBtn = 2;
          }
        });
    },
  
    noCreate: function () {
      // Utils.Tracker.send({
      //     data: {
      //         f: 'wifiins',
      //         b: 'ins_mypro_pop'
      //     }
      // });
      safe.model({
        title: "温馨提示",
        content: "抱歉，您暂时还未参保，请先点击免费参保",
        foot: "我知道了",
      });
      safe.bindModelEvent();
    },
  },
};
</script>

<style scoped>
.halfwidth {
  width: 50% !important;
}
.main {
  width: 100%;
  overflow-x: hidden;
  margin: 0 auto;
}
.banner {
  padding: 4% 4.8%;
  margin-bottom: 11px;
  background: #fff;
}
.banner p {
  padding: 0;
  color: #787878;
  font-size: 13px;
  line-height: 21px;
}
.protect {
  position: relative;
  text-align: center;
}
.protect p {
  font-size: 16px;
  line-height: 60px;
  color: #000;
  font-weight: 600;
}
.protect .line {
  position: absolute;
  top: 29px;
  width: 34.66%;
  height: 1px;
  background: #e8e8e8;
}
.protect .left {
  left: -1%;
}
.protect .right {
  right: -1%;
}
.detail-item {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
}
.detail-item .left {
  float: left;
  color: #626262;
  vertical-align: middle;
  height: 32px;
  font-weight: 300;
}
.detail-item .right {
  float: right;
  color: #151515;
  vertical-align: middle;
  height: 32px;
}
.detail-item .big {
  float: none;
  font-size: 22px;
  color: #3474b8;
  margin: 0 3px;
}
.detail .btn {
  color: #0285f0;
  font-size: 14px;
  line-height: 60px;
}
.detail .left-panel,
.detail .right-panel {
  position: relative;
  display: inline-block;
  width: 49%;
  padding: 0;
  margin: 0;
  padding-bottom: 43px;
}
.detail .right-panel {
}
.detail .icon {
  width: 100%;
  padding-top: 28%;
  margin-top: 26px;
  margin-bottom: 17px;
}
.icon1 {
  background: url(../images/index/icon1.png) no-repeat center;
  background-size: contain;
}
.icon2 {
  background: url(../images/index/icon2.png) no-repeat center;
  background-size: contain;
}
.detail .left-panel p,
.detail .right-panel p {
  padding: 0;
  margin: 0;
  color: #3f3f3f;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
}
.logo-image {
  margin-top: 30px;
  width: 100%;
  padding-top: 2.9%;
  background: url(../images/index/logo-image.png) no-repeat center;
  background-size: contain;
}
.copyright {
  font-size: 12px;
  line-height: 26px;
  color: #e0e0e0;
  text-align: center;
  font-weight: 300;
  padding-bottom: 60px;
}
.title .already {
  font-size: 14px;
  line-height: 26px;
  color: #666666;
  font-weight: 400;
  padding-bottom: 14px;
  border-bottom: 1px solid #e8e8e8;
}
.al-item {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
}
.al-item .left {
  float: left;
}
.al-item .right {
  float: right;
}
.al-item .a {
  display: block;
  text-decoration: underline;
  color: #0285f0;
}
</style>



// WEBPACK FOOTER //
// detail.vue?85f72208